var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 10H3.33333C2.59667 10 2 9.40333 2 8.66667V3.33333C2 2.59667 2.59667 2 3.33333 2H8.66667C9.40333 2 10 2.59667 10 3.33333V8.66667C10 9.40333 9.40333 10 8.66667 10Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 14H7.33333C6.59667 14 6 13.4033 6 12.6667V7.33333C6 6.59667 6.59667 6 7.33333 6H12.6667C13.4033 6 14 6.59667 14 7.33333V12.6667C14 13.4033 13.4033 14 12.6667 14Z",
    fill: "#757575",
    fillOpacity: 0.8,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackward);
export default ForwardRef;